/*
 * @Author: panweikang
 * @Date: 2024-01-03 09:34:14
 * @LastEditTime: 2024-07-22 23:30:58
 * @Description:年度报告页面
 */
import './index.scss'
import logo from '../../static/report/logo.png'
import btn from '../../static/report/btn.png'
import myReportPng from '../../static/report/myReport.png'
import myReportNewPng from '../../static/report/myReportNew.png'
import xiahuaPng from '../../static/report/xiahua.png'
import reportPng from '../../static/report/report.png'
import React, { useState } from 'react'
import { Swiper, Popup, Toast } from 'antd-mobile'
import MFooter from '../../components/MFooter/index'
import { useNavigate, useParams } from 'react-router-dom'
import qs from 'qs'
import MVerification from '../../components/MVerification/index'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import {
  checkPhoneApi,
  getRegionListApi,
  checkArmouryNumberApi,
  getUserInfoApi,
  checkUserViewReportApi,
  getSharePayDetailApi,
} from '../../api/yearEndReportApi'

import { topicDes, regionImage, topicImage } from './constants'
import wxConfig from '../../utils/wxConfig'

import bought2Png from '../../static/pay/bought2.png'

// let topicIndex = 0
// let isLastYear = false

const RegionalSelectionPage = () => {
  let navigate = useNavigate()
  let [visible, setVisible] = useState(false)

  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}')

  useEffect(() => {
    init()
  }, [])


  let init = async () => {
    let res = await getRegionListApi({
      year: "2023-H2"
    })

    let res1 = await getSharePayDetailApi({
      // let res = await getSharePayDetailApi({
      openId: userInfo.openId,
      year: "2023-H2"
    })

    let unLockProducts = []
    res1.data.unLockProducts.forEach((item) => {
      item.topics.forEach((it) => {
        unLockProducts.push(it.topicId)
      })
    })

    res.data.forEach((item) => {
      item.topics.forEach((it) => {
        it.unlock = unLockProducts.includes(it.topicId)
      })
    })


    setRegion(res.data)
  }

  // 大区
  let [region, setRegion] = useState([])
  // let regionImg = [selection1Png, selection2Png, selection3Png, selection4Png]
  let [regionIndex, setRegionIndex] = useState(0)

  // 话题
  let [topic, setTopic] = useState([])
  // let [topicIndex, setTopicIndex] = useState(0)

  let topicImg = [...topicImage]

  let openPopup = (item, index) => {
    setTopic(item.topics)
    setRegionIndex(index)
    setVisible(true)
  }

  let goDetail = async (index) => {
    // setIsLastYear(false)
    // setTopicIndex(index)
    // isLastYear = false
    // topicIndex = index
    // let openId = userInfo.openId
    // let res = await checkPhoneApi({ openId })
    // if (!res.data) {
    //   setVerificationVisible(true)
    // } else {
    verificationSuccess(index)
    // }
  }

  let [verificationVisible, setVerificationVisible] = useState(false)

  let verificationSuccess = async (index) => {
    // if (isLastYear) {
    //   navigate(`/rlb/YearEndReport/detail/lastYear`)
    //   return
    // }
    // console.log(topicIndex)
    let topicId = topic[index].topicId
    let res = await checkUserViewReportApi({
      topicId,
      openId: userInfo.openId,
    })

    if (res.data.isPay) {
      //  购买过 直接跳详情
      navigate(`/rlb/YearEndReport/detail/${topicId}`)
    } else {
      // //  没有购买 检查是否有锦囊
      // let res1 = await checkArmouryNumberApi({
      //   openId: userInfo.openId,
      // })
      // setVerificationVisible(false)
      // if (res1.data >= 1) {
      //   // 有锦囊 跳详情
      //   navigate(`/rlb/YearEndReport/detail/${topicId}`)
      // } else {
      // 没有锦囊 跳支付
      navigate('/rlb/YearEndReport/pay')
      // }
    }
  }
  // let [isLastYear, setIsLastYear] = useState(false)

  let goLastYearDetail = async () => {
    // let openId = userInfo.openId
    // let res = await checkPhoneApi({ openId })
    // if (!res.data) {
    //   setVerificationVisible(true)
    //   // setIsLastYear(true)
    //   isLastYear = true
    // } else {
    navigate(`/rlb/YearEndReport/detail/lastYear`)
    // }
  }
  return (
    <div className="RegionalSelectionPage">
      <div className="head">
        <img src={logo} alt="logo" />
        <div>
          <p>本报告由瑞莱博出品</p>
          <p>
            值得信赖的仓储及工业设施<span>租售专家</span>
          </p>
        </div>
        {/* <div onClick={goMineReport}>
          <img src={myReportPng} alt="myReportPng" />
          <p>我的报告</p>
        </div> */}
      </div>
      {region.map((item, index) => {
        return (
          <img
            key={item.regionId}
            className="selection"
            src={regionImage[item.regionId]}
            alt={`selection${item.id}`}
            onClick={() => {
              openPopup(item, index)
            }}
          />
        )
      })}

      {/* <img
        className="selection"
        src={reportPng}
        alt="reportPng"
        onClick={() => {
          goLastYearDetail()
        }}
      /> */}

      <MFooter />
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false)
        }}
        onClose={() => {
          setVisible(false)
        }}
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        }}
      >
        <div className="typePopup">
          <div className="typePopupHead border">
            <p>您想深入了解{topic && region[regionIndex]?.regionName}哪个话题？</p>
            <span>仅有一次免费查看报告的机会，好友助力或付费可查看更多</span>
          </div>
          {topic.map((item, index) => {
            return (
              <div
                className={topic.length - 1 == index ? 'item' : 'item border'}
                onClick={() => {
                  goDetail(index)
                }}
                key={item.topicId}
              >

                {/* {item.originalPrice == 0 && <img src={bought2Png} alt="bought2Png" />} */}
                <img src={topicImg[index]} alt={index} />
                <div>
                  <h6>{item.topicName} {item.unlock && <img src={bought2Png} alt="bought2Png" />}</h6>
                  <p>{topicDes[item.topicId]}</p>
                </div>
              </div>
            )
          })}
        </div>
      </Popup>
      {/* {createPortal(
        <MVerification
          visible={verificationVisible}
          onSuccess={verificationSuccess}
          onClose={() => {
            setVerificationVisible(false)
          }}
        />,
        document.body
      )} */}
    </div>
  )
}

let YearEndReport = () => {
  // document.title = '2023下半年度高标仓市场'
  document.title = '瑞莱博2023年物流地产年度报告'
  let navigate = useNavigate()
  // const { type } = useParams()
  // let [index, setIndex] = useState(type)
  // let [allowTouchMove, setAllowTouchMove] = useState(true)
  // let onIndexChange = (index) => {
  //   setIndex(index)
  //   // setAllowTouchMove(false)
  // }
  let goMineReport = async () => {
    navigate('/rlb/YearEndReport/mineReport')
  }

  return (
    <div className="YearEndReport2023 page">
      <RegionalSelectionPage />

      <img
        className="myReport"
        src={myReportNewPng}
        alt="myReportNewPng"
        onClick={goMineReport}
      />

      <img className="xiahuaImg" src={xiahuaPng} alt="xiahuaPng" />
    </div>
  )
}

export default YearEndReport
